module.exports = __webpack_public_path__ + "static/media/Krombacher-SerifRegular.d44604f7.woff";